import { useGame } from '../../contexts/GameContext';
import GuessRow from './GuessRow';
import './GameBoard.css';

function GameBoard() {
  const { state } = useGame();
  const { guesses, currentGuess, evaluations } = state;

  // Calculate empty rows
  const emptyRowCount = 7 - guesses.length - (currentGuess ? 1 : 0);
  const emptyRows = Array(Math.max(0, emptyRowCount)).fill('');

  return (
    <div className="game-board">
      {/* Completed guesses */}
      {guesses.map((guess, index) => (
        <GuessRow
          key={`guess-${index}`}
          guess={guess}
          evaluation={evaluations[index]}
          isRevealed={true}
          rowIndex={index}
        />
      ))}

      {/* Current guess */}
      {currentGuess && state.gameState === 'playing' && (
        <GuessRow
          key="current"
          guess={currentGuess}
          evaluation={null}
          isRevealed={false}
          isCurrent={true}
        />
      )}

      {/* Empty rows */}
      {emptyRows.map((_, index) => (
        <GuessRow
          key={`empty-${index}`}
          guess=""
          evaluation={null}
          isRevealed={false}
        />
      ))}
    </div>
  );
}

export default GameBoard;